module.exports = __webpack_public_path__ + "static/img/cd_gs.41da166c.png";